<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h3>{{ $t("SalonProvider.salonDataAdd") }}</h3>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h4>
            {{ $t("SalonProvider.providerData") }}
          </h4>
          <!-- Start:: Phone Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('SalonProvider.phone')"
            v-model.trim="data.phone"
            required
          />
          <base-input
            col="6"
            type="password"
            :placeholder="$t('SalonProvider.password')"
            v-model.trim="data.password"
            required
            :readonly="true"
          />
          <base-input
            col="6"
            type="password"
            :placeholder="$t('SalonProvider.checkPassword')"
            v-model.trim="data.passwordConfirmation"
            required
            :readonly="true"
          />
          <hr />

          <h4>
            {{ $t("SalonProvider.salonData") }}
          </h4>
          <!-- Start:: Logo Image -->
          <div class="table_image_wrapper m-auto">
            <base-image-upload-input
              col="12"
              identifier="logo"
              @selectImage="logoSelectImage"
              :preSelectedImage="data.logo.path"
              :placeholder="$t('SalonProvider.salonLogo')"
              required
            />
          </div>
          <!-- End:: Item Image -->
          <!-- Start:: laundry Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonNameAr')"
            v-model.trim="data.salonNameAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonNameEn')"
            v-model.trim="data.salonNameEn"
            required
          />
          <base-input
            col="6"
            type="number"
            :placeholder="$t('SalonProvider.salonPhone')"
            v-model.trim="data.salonPhone"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonEmail')"
            v-model.trim="data.salonEmail"
            required
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonDescAr')"
            v-model.trim="data.salonDescAr"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SalonProvider.salonDescEn')"
            v-model.trim="data.salonDescEn"
            required
          />

          <base-select-input
            class="placeholder_input"
            col="6"
            :optionsList="types"
            :placeholder="$t('SalonProvider.salonType')"
            v-model="data.type"
            required
            @input="isChecked = !data.type?.value == 'freelance'"
          />

          <base-switch-input
            class="placeholder_input"
            col="6"
            :label="$t('SalonProvider.salonSubBranch')"
            v-model="isChecked"
            v-if="data.type?.value == 'salon'"
          />

          <base-select-input
            v-if="isChecked && data.type?.value == 'salon'"
            class="placeholder_input"
            col="6"
            :optionsList="salons"
            :placeholder="$t('SalonProvider.mainSalonName')"
            v-model="data.subBranch"
            required
          />
          <!-- Start:: Item Image -->
          <div class="table_image_wrapper m-auto">
            <base-image-upload-input
              col="12"
              identifier="commercial"
              @selectImage="comSelectImage"
              :preSelectedImage="data.commercialRegister.path"
              :placeholder="$t('SalonProvider.salonDocument')"
              required
            />
          </div>
          <!-- End:: Item Image -->
          <!-- Start:: Categories -->
          <h4>
            {{ $t("SalonProvider.salonCat") }}
          </h4>

          <base-select-input
            col="6"
            :optionsList="allCategories"
            :placeholder="$t('SalonProvider.categories')"
            v-model.trim="data.categories"
            :multiple="true"
            required
          />
          <!-- End:: Categories -->
          <hr />
          <h4>
            {{ $t("SalonProvider.salonAddress") }}
          </h4>
          <!-- Start:: Region Input -->
          <base-select-input
            class="placeholder_input"
            col="4"
            :optionsList="regions"
            :placeholder="$t('SalonProvider.salonRegion')"
            v-model="data.region"
            required
          />

          <!-- Start:: Address Input -->
          <base-input
            col="8"
            type="text"
            :placeholder="$t('SalonProvider.address')"
            v-model.trim="data.address"
            required
          />

          <!-- Start:: Map Address Input -->
          <div class="map_wrapper">
            <ChangableMapComponent
              :lat="parseFloat(data.lat)"
              :lng="parseFloat(data.lng)"
              @update:lat="data.lat = $event"
              @update:lng="data.lng = $event"
            />
          </div>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import ChangableMapComponent from "@/components/general/ChangableMapComponent.vue";

export default {
  name: "ShowJoinProvider",
  components: {
    ChangableMapComponent,
  },
  computed: {
    types() {
      return [
        {
          id: 0,
          name: this.$t("SalonProvider.salon"),
          value: "salon",
        },
        {
          id: 1,
          name: this.$t("SalonProvider.freelance"),
          value: "freelancer",
        },
      ];
    },
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      // Start:: Data Collection To Send
      data: {
        logo: {
          path: null,
          file: null,
        },
        name: null,
        password: null,
        passwordConfirmation: null,
        email: null,
        phone: null,
        salonNameAr: null,
        salonNameEn: null,
        salonPhone: null,
        salonEmail: null,
        salonDescAr: null,
        salonDescEn: null,
        commercialRegister: {
          path: null,
          file: null,
        },
        categories: [],
        type: null,
        subBranch: null,
        region: null,
        address: null,
        lat: 23.848671758893115,
        lng: 44.64042782849206,
      },
      allCategories: [],
      regions: [],
      salons: [],
      whatType: null,
      isChecked: false,
      // End:: Data Collection To Send
    };
  },

  methods: {
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
          params: {
            isActive: 1,
          },
        });
        console.log("regions", res);

        this.regions = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getCategories() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories`,
          params: {
            isActive: 1,
          },
        });

        this.allCategories = res.data.data.data.map((cat) => ({
          id: cat.id,
          name: cat.name,
        }));
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // Start:: Get Salons To Show
    async getSalons() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `salons?ignorePermissionCheck=1`,
        });
        // Start:: Set Data

        console.log("salons", res);

        const salonsData = res.data.data.data;
        this.salons = salonsData;
      } catch (error) {
        console.log(error);
      }
    },
    logoSelectImage(selectedImage) {
      this.data.logo = selectedImage;
    },
    comSelectImage(selectedImage) {
      this.data.commercialRegister = selectedImage;
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.phone) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mobileNumber"));
        return;
      } else if (!this.data.password) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.password"));
        return;
      } else if (this.data.password.length < 6) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.passwordLength"));
        return;
      } else if (!this.data.passwordConfirmation) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.password"));
        return;
      } else if (this.data.passwordConfirmation.length < 6) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.passwordLength"));
        return;
      } else if (this.data.password != this.data.passwordConfirmation) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.notEqualPasswords"));
        return;
      } else if (!this.data.logo.file) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.logo"));
        return;
      } else if (!this.data.salonNameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      } else if (!this.data.salonNameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      } else if (!this.data.salonPhone) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.salonPhone"));
        return;
      } else if (!this.data.salonEmail) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.email"));
        return;
      } else if (!this.data.salonDescAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.salonDescAr"));
        return;
      } else if (!this.data.salonDescEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.salonDescEn"));
        return;
      } else if (!this.data.type) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.salonType"));
        return;
        // } else if (this.data.type.value === "salon" && !this.isChecked) {
        //   this.isWaitingRequest = false;
        //   this.$message.error(this.$t("VALIDATION.salonSubBranch"));
        //   return;
      } else if (
        this.data.type.value === "salon" &&
        !this.data.subBranch &&
        this.isChecked
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mainSalonName"));
        return;
      } else if (!this.data.commercialRegister.file) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.commercialRegister"));
        return;
      } else if (!this.data.categories.length) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.categories"));
        return;
      } else if (!this.data.region) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.region"));
        return;
      } else if (!this.data.address) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.address"));
        return;
      } else if (!this.data.lat || !this.data.lng) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mapLocation"));
        return;
      } else {
        this.submitForm();
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.logo.file) {
        REQUEST_DATA.append("salon[logo]", this.data.logo.file);
      }
      if (this.data.commercialRegister.file) {
        REQUEST_DATA.append(
          "salon[document]",
          this.data.commercialRegister.file
        );
      }
      this.data.categories.forEach((cat) => {
        REQUEST_DATA.append("salon[category_ids][]", cat.id);
      });
      REQUEST_DATA.append("user[password]", this.data.password);
      REQUEST_DATA.append(
        "user[password_confirmation]",
        this.data.passwordConfirmation
      );
      REQUEST_DATA.append("user[mobile]", this.data.phone);
      REQUEST_DATA.append("salon[mobile]", this.data.salonPhone);
      REQUEST_DATA.append("user[email]", this.data.salonEmail);
      REQUEST_DATA.append("salon[name][ar]", this.data.salonNameAr);
      REQUEST_DATA.append("salon[name][en]", this.data.salonNameEn);
      REQUEST_DATA.append("salon[description][ar]", this.data.salonDescAr);
      REQUEST_DATA.append("salon[description][en]", this.data.salonDescEn);
      REQUEST_DATA.append("salon[type]", this.data.type.value);
      if (!this.isChecked) {
        REQUEST_DATA.append("salon[main_branch_id]", "");
      } else {
        REQUEST_DATA.append("salon[main_branch_id]", this.data.subBranch.id);
      }
      REQUEST_DATA.append("user_info[lat]", this.data.lat);
      REQUEST_DATA.append("user_info[long]", this.data.lng);
      REQUEST_DATA.append("user_info[region_id]", this.data.region.id);
      REQUEST_DATA.append("user_info[address]", this.data.address);
      // End:: Append Request Data
      try {
        let res = await this.$axios({
          method: "POST",
          url: `providers`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    this.getSalons();
    this.getRegions();
    this.getCategories();
    // End:: Fire Methods
  },
};
</script>
<style scoped>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}

.table_image_wrapper {
  margin-bottom: 25px;
}

.category_wrapper > span {
  background: #b67071;
  text-align: center;
  font-size: medium;
  color: white;
}
</style>
